<template>
  <div class="card border-0 radius-7 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between"
      >
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Data do pagamento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Espaço utilizado
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in getPaymentHistory" :key="key">
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.date_payment }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.status }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.total_size }} GB
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                R$ {{ item.value }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: "PaymentHistory",
  data() {
    return {};
  },
  computed:{
    ...mapGetters([
      'getPaymentHistory'
    ])
  },
  methods: {
    ...mapActions([
        "setLastLogsPaymentHistory"
    ]),
  },
  created() {
    this.setLastLogsPaymentHistory();
  }
});
</script>